export const generateImageUrl = (image, source = null) =>
  source === 'MAGNOLIA'
    ? image
    : `${process.env.REACT_APP_BASE_URL}/ScopeOneApi/images/announcement-img?imageName=${image}`;
